import { Config, IDS } from "@blockworks-foundation/mango-client";

export const CLUSTER = "mainnet";
export const DEFAULT_MANGO_GROUP_NAME = "mainnet.1";
export const DEFAULT_MANGO_GROUP_CONFIG = Config.ids().getGroup(CLUSTER, DEFAULT_MANGO_GROUP_NAME);

export const FALLBACK_MANGO_GROUP_IDS = {
  cluster: "mainnet",
  name: "mainnet.1",
  publicKey: "98pjRuQjK3qA6gXts96PqZT4Ze5QmnCmt3QYjhbUSPue",
  quoteSymbol: "USDC",
  mangoProgramId: "mv3ekLzLbnVPNxjSKvqBpU3ZeZXPQdEC3bp5MDEBG68",
  serumProgramId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
  tokens: [
    {
      symbol: "USDC",
      mintKey: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
      decimals: 6,
      rootKey: "AMzanZxMirPCgGcBoH9kw4Jzi9LFMomyUCXbpzDeL2T8",
      nodeKeys: ["BGcwkj1WudQwUUjFk78hAjwd1uAm8trh1N4CJSa51euh"],
    },
    {
      symbol: "MNGO",
      mintKey: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
      decimals: 6,
      rootKey: "8HjXYFntHMDNJKCJpHFufDaFYXfuAk6c6odfFnWc4xWy",
      nodeKeys: ["8XZx15vqdUbt3eVTXsxPfEMS3o2KXJ5sM7G2qXmmkETk"],
    },
    {
      symbol: "BTC",
      mintKey: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
      decimals: 6,
      rootKey: "8VwAANqu3t4KQKpMq7wrS6yg5GTHwJBFsrK4Tk2cFN3q",
      nodeKeys: ["7CfvGCV7qMf7im7mcqftZxQZGTweGappvL1maH7PMZ3Q"],
    },
    {
      symbol: "ETH",
      mintKey: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
      decimals: 6,
      rootKey: "FDpHjPQnUkmYVpAEVBpzb3sQgjZM7fanJoRb1VVtjF6u",
      nodeKeys: ["B6mYWs6PKda8DtJwvkvk2UV88NCChdmFGhcWSrgxY5vb"],
    },
    {
      symbol: "SOL",
      mintKey: "So11111111111111111111111111111111111111112",
      decimals: 9,
      rootKey: "7jH1uLmiB2zbHNe6juZZYjQCrvquakTwd3yMaQpeP8rR",
      nodeKeys: ["2bqJYcA1A8gw4qJFjyE2G4akiUunpd9rP6QzfnxHqSqr"],
    },
    {
      symbol: "USDT",
      mintKey: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
      decimals: 6,
      rootKey: "4GYDmgvMpBx2n2iSmaS1xhZnwebR2gJ5V7UYUBA1PkJi",
      nodeKeys: ["FYFJ4YHDEJnX7yVPoejUTAcKstnovTZpLq5zWAM7c6Uz"],
    },
    {
      symbol: "SRM",
      mintKey: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
      decimals: 6,
      rootKey: "AjMbjA1JsHh574Eo1RRV2XXtB8St139oBXKPXPo2HLdU",
      nodeKeys: ["qsGcM7VLiywm1wvvvjzWd7SynnyMcg8Pc7QxKUW4CUY"],
    },
    {
      symbol: "RAY",
      mintKey: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
      decimals: 6,
      rootKey: "7TNHrBUDH3FL9uy9hxjmRcKNNaCBG9sYPuDJSJuj3LGs",
      nodeKeys: ["GDNCSCaVzhD2L164GwUv8JqTdaHCuYGg21JjXQDtuofk"],
    },
    {
      symbol: "COPE",
      mintKey: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
      decimals: 6,
      rootKey: "6cMrtzhWNEEDkcSMx19orcred8h9HyRb31MtbCkKDdf6",
      nodeKeys: ["2CpaAtjDt4s9Fps7dyJUaUMeUGBDPAUUui5rxYbVzPfA"],
    },
    {
      symbol: "FTT",
      mintKey: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
      decimals: 6,
      rootKey: "9i35wTe5W9vVLUJnzuhnFZbLThYJr2NF38MhEGVHJY5T",
      nodeKeys: ["8Q9JVDynPbyqXfnDXT31mncD7LAnoHAoSv2ywxZHjPFJ"],
    },
    {
      symbol: "MSOL",
      mintKey: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
      decimals: 9,
      rootKey: "5AWnWCNKSzdpgyJSD3NWdarMazCGX2t8D4NU5xwSEVjC",
      nodeKeys: ["H9jHd5YsHN4fg17aqng2WzJGTyinMDyQ2jin3iuiXPVD"],
    },
  ],
  oracles: [
    {
      symbol: "MNGO",
      publicKey: "49cnp1ejyvQi3CJw3kKXNCDGnNbWDuZd3UG3Y2zGvQkX",
    },
    {
      symbol: "BTC",
      publicKey: "GVXRSBjFk6e6J3NbVPXohDJetcTjaeeuykUpbQF8UoMU",
    },
    {
      symbol: "ETH",
      publicKey: "JBu1AL4obBcCMqKBBxhpWCNUt136ijcuMZLFvTP7iWdB",
    },
    {
      symbol: "SOL",
      publicKey: "H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG",
    },
    {
      symbol: "USDT",
      publicKey: "3vxLXJqLqF3JG5TCbYycbKWRBbCJQLxQmBGCkyqEEefL",
    },
    {
      symbol: "SRM",
      publicKey: "3NBReDRTLKMQEKiLD5tGcx4kXbTf88b7f2xLS9UuGjym",
    },
    {
      symbol: "RAY",
      publicKey: "AnLf8tVYCM816gmBjiy8n53eXKKEDydT5piYjjQDPgTB",
    },
    {
      symbol: "COPE",
      publicKey: "9xYBiDWYsh2fHzpsz3aaCnNHCKWBNtfEDLtU6kS4aFD9",
    },
    {
      symbol: "FTT",
      publicKey: "8JPJJkmDScpcNmBRKGZuPuG2GYAveQgP3t5gFuMymwvF",
    },
    {
      symbol: "ADA",
      publicKey: "3pyn4svBbxJ9Wnn3RVeafyLWfzie6yC5eTig2S62v9SC",
    },
    {
      symbol: "MSOL",
      publicKey: "E4v1BBgoso9s64TQvmyownAVJbhbEPGyzA3qn4n46qj9",
    },
  ],
  perpMarkets: [
    {
      name: "MNGO-PERP",
      publicKey: "4nfmQP3KmUqEJ6qJLsS3offKgE96YUB4Rp7UQvm2Fbi9",
      baseSymbol: "MNGO",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 0,
      bidsKey: "4XU8wH9ivp7x7ohhTbWUZabg5WVkF7sBtqQCmFEV6qiN",
      asksKey: "4ZkS7ZZkxfsC3GtvvsHP3DFcUeByU9zzZELS4r8HCELo",
      eventsKey: "7orixrhZpjvofZGWZyyLFxSEt2tfFiost5kHEzd7jdet",
    },
    {
      name: "BTC-PERP",
      publicKey: "DtEcjPLyD4YtTBB4q8xwFZ9q49W89xZCZtJyrGebi5t8",
      baseSymbol: "BTC",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 1,
      bidsKey: "Bc8XaK5UTuDSCBtiESSUxBSb9t6xczhbAJnesPamMRir",
      asksKey: "BkWRiarqxP5Gwx7115LQPbjRmr3NjuSRXWBnduXXLGWR",
      eventsKey: "7t5Me8RieYKsFpfLEV8jnpqcqswNpyWD95ZqgUXuLV8Z",
    },
    {
      name: "ETH-PERP",
      publicKey: "DVXWg6mfwFvHQbGyaHke4h3LE9pSkgbooDSDgA4JBC8d",
      baseSymbol: "ETH",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 2,
      bidsKey: "DQv2sWhaHYbKrobHH6jAdkAXw13mnDdM9hVfRQtrUcMe",
      asksKey: "8NhLMV6huneGAqijuUgUFSshbAfXxdNj6ZMHSLb9aW8K",
      eventsKey: "9vDfKNPJkCvQv9bzR4JNTGciQC2RVHPVNMMHiVDgT1mw",
    },
    {
      name: "SOL-PERP",
      publicKey: "2TgaaVoHgnSeEtXvWTx13zQeTf4hYWAMEiMQdcG6EwHi",
      baseSymbol: "SOL",
      baseDecimals: 9,
      quoteDecimals: 6,
      marketIndex: 3,
      bidsKey: "Fu8q5EiFunGwSRrjFKjRUoMABj5yCoMEPccMbUiAT6PD",
      asksKey: "9qUxMSWBGAeNmXusQHuLfgSuYJqADyYoNLwZ63JJSi6V",
      eventsKey: "31cKs646dt1YkA3zPyxZ7rUAkxTBz279w4XEobFXcAKP",
    },
    {
      name: "SRM-PERP",
      publicKey: "4GkJj2znAr2pE2PBbak66E12zjCs2jkmeafiJwDVM9Au",
      baseSymbol: "SRM",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 5,
      bidsKey: "E8Dv9giJQgPqNaBxF9WKDUhJD7GZ5fwXfF1NQfeCCaQp",
      asksKey: "GMv773oHiNd4jaj8uQvr1kbzroY5BDK7QTNHD14ATjGJ",
      eventsKey: "BXSPmdHWP6fMqsCsT6kG8UN9uugAJxdDkQWy87njUQnL",
    },
    {
      name: "RAY-PERP",
      publicKey: "6WGoQr5mJAEpYCdX6qjju2vEnJuD7e8ZeYes7X7Shi7E",
      baseSymbol: "RAY",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 6,
      bidsKey: "9AHm1nsxG1e3zkHnFLzYUXd17qnCgM7aFJDDApXXrhVU",
      asksKey: "43dVtcFTgDHHr32V6vhvxU2gg11wK7oyK8DdfTQ2pQsy",
      eventsKey: "Css2MQhEvXMTKjp9REVZR9ZyUAYAZAPrnDvRoPxrQkeN",
    },
    {
      name: "FTT-PERP",
      publicKey: "AhgEayEGNw46ALHuC5ASsKyfsJzAm5JY8DWqpGMQhcGC",
      baseSymbol: "FTT",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 8,
      bidsKey: "5xihpD8yz9vt95WSHVpW8pVykffW7h5VHb2LkhGBMUck",
      asksKey: "G9HtAEwHRYBrz9ZpdDJH8Qs1hEZqNJ1BPm3veBsmEXbX",
      eventsKey: "5pHAhyEphQRVvLqvYF7dziofR52yZWuq8DThQFJvJ7r5",
    },
    {
      name: "ADA-PERP",
      publicKey: "Bh9UENAncoTEwE7NDim8CdeM1GPvw6xAT4Sih2rKVmWB",
      baseSymbol: "ADA",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 9,
      bidsKey: "ivYhvYgribqdCzDg4m8fUF9ejgJHE4mnRUseR4d9khN",
      asksKey: "F4UTmEXxEUgGSL7P3HePAuz3PsXvx6hWr256vqVnzxKE",
      eventsKey: "G6Dsw9KnP4G38hePtedTH6gDfDQmPJGJw8zipBJvKc12",
    },
  ],
  spotMarkets: [
    {
      name: "MNGO/USDC",
      publicKey: "3d4rzwpy9iGdCZvgxcu7B1YocYffVLsQXPXkBZKt2zLc",
      baseSymbol: "MNGO",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 0,
      bidsKey: "3nAdH9wTEhPoW4e2s8K2cXfn4jZH8FBCkUqtzWpsZaGb",
      asksKey: "HxbWm3iabHEFeHG9LVGYycTwn7aJVYYHbpQyhZhAYnfn",
      eventsKey: "H1VVmwbM96BiBJq46zubSBm6VBhfM2FUhLVUqKGh1ee9",
    },
    {
      name: "BTC/USDC",
      publicKey: "A8YFbxQYFVqKZaoYJLLUVcQiWP7G2MeEgW5wsAQgMvFw",
      baseSymbol: "BTC",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 1,
      bidsKey: "6wLt7CX1zZdFpa6uGJJpZfzWvG6W9rxXjquJDYiFwf9K",
      asksKey: "6EyVXMMA58Nf6MScqeLpw1jS12RCpry23u9VMfy8b65Y",
      eventsKey: "6NQqaa48SnBBJZt9HyVPngcZFW81JfDv9EjRX2M4WkbP",
    },
    {
      name: "ETH/USDC",
      publicKey: "4tSvZvnbyzHXLMTiFonMyxZoHmFqau1XArcRCVHLZ5gX",
      baseSymbol: "ETH",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 2,
      bidsKey: "8tFaNpFPWJ8i7inhKSfAcSestudiFqJ2wHyvtTfsBZZU",
      asksKey: "2po4TC8qiTgPsqcnbf6uMZRMVnPBzVwqqYfHP15QqREU",
      eventsKey: "Eac7hqpaZxiBtG4MdyKpsgzcoVN6eMe9tAbsdZRYH4us",
    },
    {
      name: "SOL/USDC",
      publicKey: "9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT",
      baseSymbol: "SOL",
      baseDecimals: 9,
      quoteDecimals: 6,
      marketIndex: 3,
      bidsKey: "14ivtgssEBoBjuZJtSAPKYgpUK7DmnSwuPMqJoVTSgKJ",
      asksKey: "CEQdAFKdycHugujQg9k2wbmxjcpdYZyVLfV9WerTnafJ",
      eventsKey: "5KKsLVU6TcbVDK4BS6K1DGDxnh4Q9xjYJ8XaDCG5t8ht",
    },
    {
      name: "USDT/USDC",
      publicKey: "77quYg4MGneUdjgXCunt9GgM1usmrxKY31twEy3WHwcS",
      baseSymbol: "USDT",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 4,
      bidsKey: "37m9QdvxmKRdjm3KKV2AjTiGcXMfWHQpVFnmhtb289yo",
      asksKey: "AQKXXC29ybqL8DLeAVNt3ebpwMv8Sb4csberrP6Hz6o5",
      eventsKey: "9MgPMkdEHFX7DZaitSh6Crya3kCCr1As6JC75bm3mjuC",
    },
    {
      name: "SRM/USDC",
      publicKey: "ByRys5tuUWDgL73G8JBAEfkdFf8JWBzPBDHsBVQ5vbQA",
      baseSymbol: "SRM",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 5,
      bidsKey: "AuL9JzRJ55MdqzubK4EutJgAumtkuFcRVuPUvTX39pN8",
      asksKey: "8Lx9U9wdE3afdqih1mCAXy3unJDfzSaXFqAvoLMjhwoD",
      eventsKey: "6o44a9xdzKKDNY7Ff2Qb129mktWbsCT4vKJcg2uk41uy",
    },
    {
      name: "RAY/USDC",
      publicKey: "2xiv8A5xrJ7RnGdxXB42uFEkYHJjszEhaJyKKt4WaLep",
      baseSymbol: "RAY",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 6,
      bidsKey: "Hf84mYadE1VqSvVWAvCWc9wqLXak4RwXiPb4A91EAUn5",
      asksKey: "DC1HsWWRCXVg3wk2NndS5LTbce3axwUwUZH1RgnV4oDN",
      eventsKey: "H9dZt8kvz1Fe5FyRisb77KcYTaN8LEbuVAfJSnAaEABz",
    },
    {
      name: "COPE/USDC",
      publicKey: "6fc7v3PmjZG9Lk2XTot6BywGyYLkBQuzuFKd4FpCsPxk",
      baseSymbol: "COPE",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 7,
      bidsKey: "FLjCjU5wLUsqF6FeYJaH5JtTTFSTZzTCingxN1uyr9zn",
      asksKey: "7TcstD7AdWqjuFoRVK24zFv66v1qyMYDNDT1V5RNWKRz",
      eventsKey: "2dQ1Spgc7rGSuE1t3Fb9RL7zvGc7F7pH9XwJ46u3QiJr",
    },
    {
      name: "FTT/USDC",
      publicKey: "2Pbh1CvRVku1TgewMfycemghf6sU9EyuFDcNXqvRmSxc",
      baseSymbol: "FTT",
      baseDecimals: 6,
      quoteDecimals: 6,
      marketIndex: 8,
      bidsKey: "9HTDV2r7cQBUKL3fgcJZCUfmJsKA9qCP7nZAXyoyaQou",
      asksKey: "EpnUJCMCQNZi45nCBoNs6Bugy67Kj3bCSTLYPfz6jkYH",
      eventsKey: "2XHxua6ZaPKpCGUNvSvTwc9teJBmexp8iMWCLu4mtzGb",
    },
    {
      name: "MSOL/USDC",
      publicKey: "6oGsL2puUgySccKzn9XA9afqF217LfxP5ocq4B3LWsjy",
      baseSymbol: "MSOL",
      baseDecimals: 9,
      quoteDecimals: 6,
      marketIndex: 10,
      bidsKey: "8qyWhEcpuvEsdCmY1kvEnkTfgGeWHmi73Mta5jgWDTuT",
      asksKey: "PPnJy6No31U45SVSjWTr45R8Q73X6bNHfxdFqr2vMq3",
      eventsKey: "BC8Tdzz7rwvuYkJWKnPnyguva27PQP5DTxosHVQrEzg9",
    },
  ],
};

export const defaultMangoGroupIds =
  IDS["groups"].find((group) => group.name === DEFAULT_MANGO_GROUP_NAME) || FALLBACK_MANGO_GROUP_IDS;
